export const fontDefault = "var(--font-tt-hoves, 'TT Hoves', system-ui)";
export const fontInter = "var(--font-inter, 'Inter', system-ui)";
export const fontPlayfair = "var(--font-playfair, 'Playfair Display', serif)";
export const fontMonospaced = "'SFMono-Regular', Menlo, Monaco, Consolas, monospace !important";
